import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./_utils/ARRAY"
import "./_utils/STRING"
import echarts from 'echarts'
console.clear()
Vue.prototype.$echarts = echarts
//////////////////////////////////////////////////
Vue.use(VueRouter)
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => err)
}
////////////////////////////////////////////////
Vue.use(ElementUI);
Vue.component('page-frame', () => import(`@/_uc/page-frame.vue`))
Vue.component('nav-button', () => import(`@/_uc/nav-button.vue`))
Vue.component('image-uploader', () => import(`@/_uc/image-uploader.vue`))
Vue.component('images-uploader', () => import(`@/_uc/images-uploader.vue`))
Vue.component('model-uploader', () => import(`@/_uc/model-uploader.vue`))
Vue.config.productionTip = false

const paths = [
  "/index",

  "/activity/add",
  "/activity/delete",
  "/activity/update",
  "/activity/list",

  "/category1/add",
  "/category1/delete",
  "/category1/update",
  "/category1/list",

  "/category2/add",
  "/category2/delete",
  "/category2/update",
  "/category2/list",

  "/category/add",
  "/category/delete",
  "/category/update",
  "/category/list",

  "/ad/add",
  "/ad/delete",
  "/ad/update",
  "/ad/list",

  "/client/list",
  "/client/orders",
  "/client/view_done",
  "/client/buy_report",

  "/fee/index",

  "/guest/login",
  "/guest/password",

  "/member/password",
  "/member/logout",

  "/product/add",
  "/product/delete",
  "/product/update",
  "/product/list",
  "/product/comment",

  "/order/list_new",
  "/order/list_pay",
  "/order/list_send",
  "/order/list_receive",
  "/order/list_done",
  "/order/list_cancel",

  "/order/view_new",
  "/order/view_pay",
  "/order/view_send",
  "/order/view_receive",
  "/order/view_done",
  "/order/view_cancel",

  "/report/index",
  "/report/month",
  "/report/quarter",
  "/report/year",

  "/recommend/index",
  "/recommend/month",
  "/recommend/quarter",
  "/recommend/year",

  "/sell/index",
  "/sell/month",
  "/sell/quarter",
  "/sell/year",

  "/buy/index",
  "/buy/month",
  "/buy/quarter",
  "/buy/year",

  "/seller/index",
  "/seller/orders",
  "/seller/view_done",
]
const routes = paths.map(path => {
  const component = () => import(`.${path}.vue`)
  return { path, component }
}).concat([
  { path: '/', redirect: "/index" },
])
const router = new VueRouter({
  mode: "history",
  routes
})
window.router = router
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
